module.exports = __webpack_public_path__ + "img/tab_img1.aff8803b.png";